import { render, staticRenderFns } from "./item-html.vue?vue&type=template&id=3e65a831&scoped=true"
import script from "./item-html.vue?vue&type=script&lang=js"
export * from "./item-html.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e65a831",
  null
  
)

export default component.exports